import { render, staticRenderFns } from "./ReChallengeRequestForm.vue?vue&type=template&id=b3595d9c&scoped=true"
import script from "./ReChallengeRequestForm.vue?vue&type=script&lang=js"
export * from "./ReChallengeRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3595d9c",
  null
  
)

export default component.exports